var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.simulationModeEnabled && _vm.hasSimulatedValue)?_c('span',{staticClass:"body-2 secondary--text"},[_c('v-icon',{staticClass:"pl-1 secondary--text",attrs:{"small":""}},[_vm._v("mdi-source-branch")]),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }